import {formatDateDisplay} from '@afriex/core/utils';

import * as formatDate from '@/utils/date';

export const isExpired = (expiresAt?: Date | string): boolean =>
  Boolean(expiresAt && new Date(expiresAt).getTime() < Date.now());

export const isFutureDate = (date: Date): boolean =>
  date.getTime() > Date.now();

export const isFutureTime = (time: Date): boolean => {
  const now = new Date();
  now.setSeconds(0, 0);
  const candidate = new Date(time);
  candidate.setSeconds(0, 0);
  return candidate.getTime() > now.getTime();
};

export const formatOptionalDate = (date?: Date | string): string =>
  date ? formatDateDisplay(date) : '-';

export const formatOptionalDateTime = (date?: Date | string): string =>
  date ? formatDate.dateTimeInTimeZone(date.toString()) : '-';
